export function setFormErrors(
	errorsItemized,
	methods
) {

	for (const field in errorsItemized) {
		const errors = errorsItemized[field];
		const fieldError = errors.join(" ");
		methods.setError(field, { message: fieldError, });
	}
}

export function formatClassNames(...props) {
	let classes = "";
	for (const className in props) {
		if (typeof props[className] === 'object') {
			const classObjects = props[className];
			for (const cn in classObjects) {
				if (classObjects[cn]) {
					classes += ` ${cn}`;
				}
			}


		} else if (typeof props[className] === 'string') {
			classes += ` ${props[className]}`;
		}

	}
	return classes.trim();

}
